import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from "react-intl";
import { getPriceListName } from '../name-helpers/priceListNameHelper';

class PaymentTypeLabel extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            standalone: this.props.standalone || false,
            nameOnly: this.props.nameOnly || false,
            uppercase: this.props.uppercase || false,
            type: this.props.value || '',
            className: this.props.className || '',
        }
    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            standalone: nextProps.standalone || false,
            type: nextProps.value || '',
            className: nextProps.className || '',
        })
    }

    componentDidMount() { }



    render() {
        if (!this.state.type) {
            return ''
        }
        let paymentTypeLabel = <FormattedMessage
            id="invoice.analytics.events.payment_received.lowercase_payment_type_label"
            defaultMessage="payment"
        />
        switch (this.state.type) {
            case 'check':
                paymentTypeLabel = this.state.nameOnly ? <FormattedMessage
                    id="invoice.receive_payment.check_label"
                    defaultMessage="Check"
                /> : <FormattedMessage
                    id="invoice.analytics.events.payment_received.lowercase_check_payment_type_label"
                    defaultMessage="bank check payment"
                />
                break
            case 'cash':
                paymentTypeLabel = this.state.nameOnly ? <FormattedMessage
                    id="invoice.receive_payment.cash_label"
                    defaultMessage="Cash"
                /> : <FormattedMessage
                    id="invoice.analytics.events.payment_received.lowercase_cash_payment_type_label"
                    defaultMessage="cash payment"
                />
                break
            case 'credit-card':
                paymentTypeLabel = this.state.nameOnly ? <FormattedMessage
                    id="invoice.receive_payment.credit_card_label"
                    defaultMessage="Credit card"
                /> : <FormattedMessage
                    id="invoice.analytics.events.payment_received.lowercase_credit_card_payment_type_label"
                    defaultMessage="credit card payment"
                />
                break
            case 'on-account':
                paymentTypeLabel = this.state.nameOnly ? <FormattedMessage
                    id="invoice.receive_payment.on_account_label"
                    defaultMessage="On account"
                /> : <FormattedMessage
                    id="invoice.analytics.events.payment_received.lowercase_on_account_payment_type_label"
                    defaultMessage="on account payment"
                />
                break
            case 'bank-transfer':
                paymentTypeLabel = this.state.nameOnly ? <FormattedMessage
                    id="invoice.receive_payment.bank_transfer_label"
                    defaultMessage="Bank transfer"
                /> : <FormattedMessage
                    id="invoice.analytics.events.payment_received.lowercase_bank_transfer_payment_type_label"
                    defaultMessage="bank transfer payment"
                />
                break
            case 'credit':
                paymentTypeLabel = this.state.nameOnly ? <FormattedMessage
                    id="invoice.receive_payment.credit_label_without_amount"
                    defaultMessage="Credit"
                /> : <FormattedMessage
                    id="invoice.analytics.events.payment_received.lowercase_credit_payment_type_label"
                    defaultMessage="credit"
                />
                break
            case 'external':
                paymentTypeLabel = this.state.nameOnly ? <FormattedMessage
                    id="invoice.receive_payment.external"
                    defaultMessage="External"
                /> : <FormattedMessage
                    id="invoice.analytics.events.payment_received.lowercase_external_payment_type_label"
                    defaultMessage="external"
                />
                break
            case 'price-list-bulk-payment':
                paymentTypeLabel = this.state.nameOnly ? <FormattedMessage
                    id="invoice.receive_payment.price_list_bulk_label"
                    defaultMessage="Bulk payment"
                /> : <FormattedMessage
                    id="invoice.analytics.events.payment_received.price_list_bulk_label"
                    defaultMessage="{priceList} bulk payment"
                    values={{
                        priceList: getPriceListName(this.props.intl)
                    }}
                />
                break
            case 'price-list-credit-memo':
                paymentTypeLabel = this.state.nameOnly ? <FormattedMessage
                    id="invoice.receive_payment.price_list_credit_memo_label"
                    defaultMessage="Credit memo"
                /> : <FormattedMessage
                    id="invoice.analytics.events.payment_received.price_list_credit_memo_label"
                    defaultMessage="{priceList} credit memo payment"
                    values={{
                        priceList: getPriceListName(this.props.intl)
                    }}
                />
                break
            case 'gift-card':
                paymentTypeLabel = this.state.nameOnly ? <FormattedMessage
                    id="invoice.receive_payment.gift_card_label"
                    defaultMessage="Gift card"
                /> : <FormattedMessage
                    id="invoice.analytics.events.payment_received.lowercase_gift_card_payment_type_label"
                    defaultMessage="gift card payment"
                />
                break
            default:
                paymentTypeLabel = this.state.nameOnly  ? this.state.type : <FormattedMessage
                    id="invoice.analytics.events.payment_received.lowercase_payment_type_default_label"
                    defaultMessage="{paymentType} payment"
                    values={{
                        paymentType: this.state.type,
                    }}
                />
        }

        if (this.state.standalone) {
            return <span style={{
                textTransform: 'capitalize'
            }}>
                {paymentTypeLabel}
            </span>
        } else if (this.state.uppercase) {
            return <span style={{
                textTransform: 'uppercase'
            }}>
                {paymentTypeLabel}
            </span>
        }

        return paymentTypeLabel
    }

}

export default injectIntl(PaymentTypeLabel)





// WEBPACK FOOTER //
// ./src/payment/label.component.jsx